"use strict";

function homeBanner() {
  jarallaxVideo();
  var videos = document.querySelector('.c-home-banner__video');
  if (videos) {
    var videoUrl = videos.dataset.url;
    jarallax(videos, {
      speed: 1,
      videoSrc: videoUrl,
      onVideoWorkerInit: function onVideoWorkerInit(videoObject) {
        if (videoObject.isValid()) {
          videoObject.on('started', function (event) {
            var parent = videoObject.$video.parentNode;
            parent.classList.add('show-video');
          });
        }
      }
    });
  }
}
homeBanner();